import { BrandLogo } from "@/components/shared/BrandLogo";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API, axios } from "@/api";
import { Loader2, Repeat, Gift, Eye, ChevronRight } from "lucide-react";

export default function OfferStickinessPanel() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/offer-stickiness`)
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-8"><Loader2 className="w-5 h-5 animate-spin text-slate-300" /></div>;
  if (!data) return <p className="text-sm text-slate-400 text-center py-4">Failed to load</p>;

  const { total_sticky_offers, offers } = data;

  if (offers.length === 0) {
    return (
      <div className="text-center py-8" data-testid="stickiness-panel">
        <Repeat className="w-8 h-8 text-slate-200 mx-auto mb-2" />
        <p className="text-sm text-slate-400">No repeat view patterns detected yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="stickiness-panel">
      <div className="bg-violet-50 rounded-xl p-3 border border-violet-100">
        <p className="text-xs text-violet-600 font-medium">Sticky Offers</p>
        <p className="text-2xl font-bold text-violet-800">{total_sticky_offers}</p>
        <p className="text-[10px] text-violet-500 mt-0.5">Offers where users come back to view multiple times — high purchase intent</p>
      </div>

      <div className="space-y-2">
        {offers.map((o) => (
          <div
            key={o.business_id}
            className="bg-white rounded-xl border border-slate-100 p-3"
            data-testid={`sticky-offer-${o.business_id}`}
          >
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg overflow-hidden flex-shrink-0 bg-slate-50 flex items-center justify-center">
                <BrandLogo name={o.name} logoUrl={o.logo_url} size="sm" />
              </div>
              <div className="flex-1 min-w-0">
                <button
                  onClick={() => navigate(`/offer/${o.business_id}`)}
                  className="text-sm font-semibold text-slate-800 truncate hover:text-violet-600 transition-colors block"
                  data-testid={`sticky-link-${o.business_id}`}
                >
                  {o.name}
                </button>
                <p className="text-[10px] text-slate-400 truncate">{o.category}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <span className="text-xs font-bold text-violet-700 bg-violet-100 px-2 py-0.5 rounded-full">
                  {o.stickiness_pct}%
                </span>
              </div>
            </div>
            <div className="flex items-center gap-4 mt-2 text-[10px] text-slate-400">
              <span className="flex items-center gap-0.5"><Repeat className="w-3 h-3" />{o.repeat_viewers} repeat viewer{o.repeat_viewers !== 1 ? "s" : ""}</span>
              <span className="flex items-center gap-0.5"><Eye className="w-3 h-3" />{o.total_repeat_views} repeat views</span>
              <span>Max: {o.max_views_by_single_user}x by 1 user</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
